import { gql } from '@apollo/client';

export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc44c1f84ffd06759c1a1e3'
  }
};

export const QUERY = `
  query customersOne ($filter: AutoFilledFilterFindOnecustomersInput!, $skip: Int, $sort: SortFindOnecustomersInput) {
    customersOne (filter: $filter, skip: $skip, sort: $sort) {
        email
        phone
        firstName
        lastName
        companyName
        address {
            address1
            address2
            address3
            state
            city
            zip
            country
            _id
        }
        companyId
        bkUser
        bkCompany
        _id
        updatedAt
        createdAt
    }
  }
`;

export const QUERYV2 = gql`
  query CustomersOneByToken($filter: AutoFilledFilterFindOnecustomersInput!, $token: String!) {
    customersOneByToken(filter: $filter, token: $token) {
      email
      phone
      firstName
      lastName
      companyName
      companyId
      defaultPaymentMethod
      defaultPaymentMethodObj {
        type
        counterParty
        name
        companyId
        direction
        provider
        customerId
        expired
        _id
        updatedAt
        createdAt
        card {
          cardNo
          cardType
          holder
          expiry
        }
        billingAddress {
          address1
          address2
          address3
          city
          country
          state
          zip
        }
      }
      abbrBusinessNumber
      businessNumber
      address {
        address1
        address2
        address3
        state
        city
        zip
        country
        _id
      }
      _id
      updatedAt
      createdAt
      fullName
    }
  }
`;
